module.exports = __webpack_public_path__ + "img/sv28.4ac0f9bb.svg";